export const TYPE_TIME = 0;
export const TYPE_CALL = 1;

/** Reservation state sentinel for an unset state1/state2 value. */
export const STATE_UNSET = -1;

export const TIMEMINUTE_MIN = -30;
export const TIMEMINUTE_MAX = 1440;

export const SMS_TYPE_NOREPLY = 0;
export const SMS_TYPE_REPLY = 1;